<template>

    <div class="margin-bg">

        <div class="card-shadow">
            <div>
                <p class=" page-title">
                    Staff
                </p>
            </div>
            <div class="btn-container">

                <div class=" flex gap-x-4">
                    <label for="search" class="search-input">
                        <input type="text" class="input-search" placeholder="Search" v-model="searchInput">
                        <i class="fal fa-search"></i>
                    </label>

                    <div class="w-full !text-sm" data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Department" @change="searchDepartmentChange()"
                            data-te-select-filter="true" name="" id="" v-model="searchDepartment" class="input-ui">
                            <option :value="department" v-for="(department, departmentIndex) in departmentList"
                                :key="departmentIndex"> {{ department.name }} </option>
                        </select>
                    </div>
                    <div class="w-full !text-sm" data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Role" @change="searchRoleChange()"
                            data-te-select-filter="true" name="" id="" v-model="searchRole" class="input-ui">
                            <option :value="role" v-for="(role, roleIndex) in searchRoleList"
                                :key="roleIndex"> {{ role.name }} </option>
                        </select>
                    </div>

                    <button class="add-btn h-8 text-[13px] font-inter" @click="searchBtnClicked">Search</button>
                    <button class="add-btn h-8 text-[13px] font-inter" @click="clearSearchBtnClicked">Clear</button>
                </div>
                <div class="flex justify-end flex-col">
                    <a  v-if="feature.includes('staff.create')" href="/staff/create" class="add-btn text-[13px] font-inter">
                        Add New
                    </a>

                </div>
            </div>
        </div>
        <div class="box-container-table">
            <div class=" overflow-x-auto">
                <!-- <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8"> -->
                <div class=" table-container">
                    <table class="primary-table">
                        <thead class="">
                            <tr>
                                <th scope="col" class="">
                                    #
                                </th>
                                <th scope="col" class=" ">
                                    Name
                                </th>
                                <th scope="col" class=" ">
                                    Phone Number
                                </th>
                                <th scope="col" class=" ">
                                    Address
                                </th>
                                <th scope="col" class=" ">
                                    Roles
                                </th>
                                <th scope="col" class=" ">
                                    Department
                                </th>
                                <th scope="col" class=" ">
                                    Status
                                </th>
                                <th scope="col" class="" v-show="['staff.toggle', 'staff.edit'].some(f => feature.includes(f))">

                                </th>

                            </tr>
                        </thead>
                        <TableSkeleton
                        v-if="loading"
                        :rows="20"
                        :cols="6"
                        />

                        <tr class=" !text-center" v-else-if="staffList.length < 1">
                            <td class="" colspan="5">
                                No Data Here
                            </td>
                        </tr>
                        <tbody v-else-if="!loading && staffList.length > 0">
                            <!-- looping start -->
                            <div class="contents" v-for="(staff, index) in staffList" :key="index">
                                <tr class="">
                                    <td class=" ">
                                        {{ perPage * (currentPage - 1) + (index + 1) }}
                                    </td>
                                    <td class="whitespace-nowrap  ">
                                        {{ staff.name }}
                                    </td>
                                    <td class="whitespace-nowrap ">
                                        {{ staff.phone_number }}

                                    </td>
                                    <td lass="whitespace-nowrap text-left  ">
                                        {{ staff.address }}
                                    </td>
                                    <td lass="whitespace-nowrap text-left  ">
                                        <div v-for="role in staff.roles" :key="role.id">
                                            {{ role.name }}
                                        </div>
                                    </td>
                                    <td lass="whitespace-nowrap text-left  ">
                                        {{ staff.department.name }}
                                    </td>
                                    <td lass="whitespace-nowrap text-left  ">
                                        <button data-te-toggle="modal" data-te-target="#change_status" class="mx-4 cursor-pointer text-blue-600"
                                            @click="statusChangeBtnClicked(staff)" title="Change Status">
                                            {{ staff.status ? staff.status : '--' }}
                                        </button>
                                        
                                    </td>
                                    <td class="whitespace-nowrap text-left relative" v-show="['staff.toggle', 'staff.edit'].some(f => feature.includes(f))">
                                        <button data-te-toggle="modal" data-te-target="#create_exam_modal" class="mx-4"
                                            @click="createExamBtnClicked(staff)" title="Take Exam">
                                            <i class="fal fa-plus"></i>
                                        </button>
                                        <button class="mx-1" data-te-toggle="modal" data-te-target="#uploadContractsModal" @click="contractUploadBtnForStaffClicked(staff.id, index)"
                                            title="Update Contract">
                                            <i class="fal fa-file-signature"></i>
                                        </button>

                                        <a v-if="feature.includes('staff.edit')" :href="'/staff/' + staff.id + '/edit'" class="pr-2 mx-1"
                                            title="Edit">
                                            <i class="fal fa-pen"></i>
                                        </a>
                                        <input v-show="feature.includes('staff.toggle')" :checked="staff.is_active == 1" @change="isActiveToggled(staff.id)"
                                            class="mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-white before:pointer-events-none before:absolute before:h-3.5
                                            before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:-mt-[0.1875rem] after:h-5
                                            after:w-5 after:rounded-full after:border-none after:bg-black after:transition-[background-color_0.2s,transform_0.2s]
                                            after:content-[''] checked:bg-black checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ms-[1.0625rem]
                                            checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-black checked:after:shadow-switch-1
                                            checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:scale-100
                                            focus:before:opacity-[0.12]  focus:before:transition-[box-shadow_0.2s,transform_0.2s]
                                            focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-['']
                                             checked:focus:before:ms-[1.0625rem] checked:focus:before:scale-100
                                            checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] "
                                            type="checkbox" role="switch" />
                                    </td>
                                </tr>
                            </div>


                            <!-- looping end -->
                        </tbody>
                    </table>
                    <div class="flex justify-center">

                        <div v-if="totalData != 0" class=" bg-white  flex justify-center mt-5 py-3">
                            <button class="rounded px-6 py-1 border  hover:bg-slate-200"
                                :disabled="currentPage === 1"
                                @click="getStaffsList(currentPage - 1)">«</button>

                            <button class=" text-sm px-5 border">
                                Page <span @dblclick="showInput">{{ currentPage }}</span> / <span
                                    class="text-gray-400">{{
                                    lastPage }}</span>
                            </button>

                            <button class=" rounded px-6  py-1 border  hover:bg-slate-200"
                                :disabled="currentPage === lastPage"
                                @click="getStaffsList(currentPage + 1)"> »</button>
                        </div>
                    </div>
                </div>

            </div>

            <!--Delete Modal -->
            <div data-te-modal-init
                class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                id="deleteModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div data-te-modal-dialog-ref
                    class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                    <div
                        class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none ">
                        <div
                            class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 ">
                            <!--Modal title-->
                            <h5 class="text-xl font-medium leading-normal text-neutral-800 " id="exampleModalLabel">
                                Delete ?
                            </h5>
                            <!--Close button-->
                            <button type="button"
                                class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                                data-te-modal-dismiss aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <!--Modal body-->
                        <div class="relative flex-auto p-4" data-te-modal-body-ref>
                            <p>
                                Are you sure ?
                            </p>
                        </div>

                        <!--Modal footer-->
                        <div
                            class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 ">
                            <button type="button"
                                class="inline-block px-6 pb-2 pt-2.5 text-xs focus:outline-none focus:ring-0 "
                                data-te-modal-dismiss>
                                Close
                            </button>
                            <button @click="confirmDeleteBtnClicked" type="button" data-te-toggle="modal"
                                data-te-target="#deleteModal"
                                class="ml-1 inline-block rounded bg-red-600 px-6 pb-2 pt-2.5 text-xs  text-white   focus:outline-none focus:ring-0 ">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-te-modal-init
            class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="uploadContractsModal" tabindex="-1" aria-labelledby="create_modalLabel" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref
                class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]">
                <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div class="relative flex justify-between py-2 px-6 border-b">
                        <h5 class="text-base text-center mt-2 font-semibold leading-normal font-inter"
                            id="create_modalLabel">
                            Upload Contracts for {{ selectedStaffName }}
                        </h5>
                        <button type="button" id="btn-close-upload-modal" class="text-xs focus:shadow-none focus:outline-none" data-te-modal-dismiss
                        aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="h-4 w-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="relative px-12 py-4" data-te-modal-body-ref>
                        <div class="mb-4">
                            <label for="" class="block text-sm text-black mb-3">
                                Contracts
                            </label>
                            <input type="file" multiple accept="image/png, image/gif, image/jpeg" id="contract-upload" ref="contractInput"
                            class="flex flex-col items-center justify-center h-12 w-full bg-gray-100 rounded-md border-2 border-gray-300
                            border-dashed transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:border-gray-600 dark:hover:bg-gray-700"
                            @change="contractFilesChange">
                            <div v-for="(preview, index) in contractFilePreviews">
                                <div class="flex items-center">
                                    <div class="contents">
                                        <img v-if="preview" :src="preview" alt="Contract Preview" class="mt-2 h-24" />
                                        <button @click="removeContractBtnClicked(index)"> <i class="fas fa-times"></i> </button>
                                    </div>
                                </div>
                            </div>                        
                        </div>
                    </div>

                    <div class="flex justify-end gap-x-4 px-6 mb-6 pt-4">
                        <button type="button" class="cancel-btn focus:shadow-none focus:outline-none"
                            data-te-modal-dismiss aria-label="Close">
                            Cancel
                        </button>
                        <LoadingButton
                            :loading="buttonLoading"
                            text="Upload"
                            loadingText="Uploading..."
                            @click="uploadContractsBtnClicked"
                        />
                        <!-- <button type="button" class="add-btn focus:outline-none focus:ring-0 "
                        data-te-modal-dismiss
                        @click="uploadContractsBtnClicked">
                            Upload
                        </button> -->
                    </div>
                </div>
            </div>
        </div>


        <!-- Button trigger modal -->
<button
  type="button"
  class=""
  hidden
  disabled
  data-te-toggle="modal"
  data-te-target="#exampleModal"
  data-te-ripple-init
  data-te-ripple-color="light">
  Launch demo modal
</button>

<!-- Modal -->
<div
  data-te-modal-init
  class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div
    data-te-modal-dialog-ref
    class="pointer-events-none relative w-auto translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
    <div
      class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-4 outline-none dark:bg-surface-dark">
      <div
        class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 p-4 dark:border-white/10">
        <h5
          class="text-xl font-medium leading-normal text-surface dark:text-white"
          id="exampleModalLabel">
          Modal title
        </h5>
        <button
          type="button"
          class="box-content rounded-none border-none text-neutral-500 hover:text-neutral-800 hover:no-underline focus:text-neutral-800 focus:opacity-100 focus:shadow-none focus:outline-none dark:text-neutral-400 dark:hover:text-neutral-300 dark:focus:text-neutral-300"
          data-te-modal-dismiss
          aria-label="Close">
          <span class="[&>svg]:h-6 [&>svg]:w-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        </button>
      </div>

      <!-- Modal body -->
      <div class="relative flex-auto p-4" data-te-modal-body-ref>
        Modal body text goes here.
      </div>

      <!-- Modal footer -->
      <div
        class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 p-4 dark:border-white/10">
        <button
          type="button"
          class="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-200 focus:bg-primary-accent-200 focus:outline-none focus:ring-0 active:bg-primary-accent-200 dark:bg-primary-300 dark:hover:bg-primary-400 dark:focus:bg-primary-400 dark:active:bg-primary-400"
          data-te-modal-dismiss
          data-te-ripple-init
          data-te-ripple-color="light">
          Close
        </button>
        <button
          type="button"
          class="ms-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-primary-3 transition duration-150 ease-in-out hover:bg-primary-accent-300 hover:shadow-primary-2 focus:bg-primary-accent-300 focus:shadow-primary-2 focus:outline-none focus:ring-0 active:bg-primary-600 active:shadow-primary-2 dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong"
          data-te-ripple-init
          data-te-ripple-color="light">
          Save changes
        </button>
      </div>
    </div>
  </div>
</div>
    </div>


<!-- exam modal -->
<div data-te-modal-init
    class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="create_exam_modal" tabindex="-1" aria-labelledby="create_exam_modalLabel" aria-hidden="true">
    <div data-te-modal-dialog-ref
        class="pointer-events-none relative w-auto mb-12 translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
        <div
            class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">

            <div class="relative flex justify-between py-2 px-6 border-b">
                <h5 class="text-base text-center mt-2 font-semibold leading-normal font-inter"
                    id="create_exam_modalLabel">
                    Create Exam
                </h5>
                <button type="button" class="text-xs focus:shadow-none focus:outline-none" data-te-modal-dismiss
                    aria-label="Close" id="close_exam_modal">  
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="h-4 w-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="relative px-6 py-4 border-b" data-te-modal-body-ref>
                <div class="mb-4">
                    <label for="" class="label-form mb-3">
                        Exam
                    </label>
                    <div class="bg-white mb-0 w-full inline-block h-[34px] dark:bg-white !text-black !text-sm"
                        data-te-select-wrapper-ref>
                        <select data-te-select-init data-te-select-placeholder="Select Exam"
                            data-te-select-filter="true" name="" id="" v-model="selectedExam" class="input-ui !text-black text-sm">
                            <option :value="exam" v-for="(exam, index) in examList"
                                :key="index"> {{ exam.name }} </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="flex justify-end gap-x-4 px-6 mb-6 pt-4">
                <button type="button" class="cancel-btn focus:shadow-none focus:outline-none"
                    data-te-modal-dismiss aria-label="Close">
                    Cancel
                </button>
                <button type="button" @click="createInterview()"
                    class="add-btn focus:outline-none focus:ring-0 ">
                    Create
                </button>
            </div>
        </div>
    </div>
</div>


    <!-- status change modal -->
    <div data-te-modal-init
        class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="change_status" tabindex="-1" aria-labelledby="change_status_modalLabel" aria-hidden="true">
        <div data-te-modal-dialog-ref
            class="pointer-events-none relative w-auto mb-12 translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
            <div
                class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">

                <div class="relative flex justify-between py-2 px-6 border-b">
                    <h5 class="text-base text-center mt-2 font-semibold leading-normal font-inter">
                        Change Status
                    </h5>
                    <button type="button" class="text-xs focus:shadow-none focus:outline-none" data-te-modal-dismiss
                        aria-label="Close" id="close_change_status_modal">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="h-4 w-4">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="relative px-6 py-4 border-b" data-te-modal-body-ref>
                    <div class="mb-4">
                        <label for="" class="label-form mb-3">
                            Status
                        </label>
                        <div class="bg-white mb-0 w-full inline-block h-[34px] dark:bg-white !text-black !text-sm"
                            data-te-select-wrapper-ref>
                            <select data-te-select-init data-te-select-placeholder="Select Status"
                                data-te-select-filter="true" name="" id="" v-model="selectedStatus" class="input-ui !text-black text-sm">
                                <option :value="status" v-for="(status, index) in statusList"
                                    :key="index"> {{ status.name }} </option>
                            </select>
                        </div>
                    </div>
                    <div v-show="selectedStatus && selectedStatus.value === 'probation'" class="mb-0 col-span-3 pb-0 rounded-md">
                        <label for="" class="block text-sm text-black mb-3">
                            Probation Month
                        </label>
                        <input type="number" v-model="selectedProbationMonth" autocomplete="off"
                            class="text-sm border border-gray-300 input-ui w-full bg-transparent rounded-lg focus:ring-0">
                    </div>
                </div>

                <!--Modal footer-->
                <div class="flex justify-end gap-x-4 px-6 mb-6 pt-4">
                    <button type="button" class="cancel-btn focus:shadow-none focus:outline-none" data-te-modal-dismiss
                        aria-label="Close">
                        Cancel
                    </button>
                    <button type="button" @click="changeStatusBtnClicked" class="add-btn focus:outline-none focus:ring-0 ">
                        Add
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal, Ripple, initTE, Input, Select, Dropdown } from "tw-elements";
import { mapGetters } from "vuex";
import { getApiData, postApiData, deleteApiData } from '../../utilities/ajax-helpers';
import TableSkeleton from "../Common/TableSkeleton.vue";
import LoadingButton from '../Common/LoadingButton.vue';

export default {
    components: {
        TableSkeleton,
        LoadingButton
    },
    data() {
        return {
            staffList: [],
            name: null,
            edit_name: null,
            team_id: null,
            keyword: null,
            department: null,
            departmentList: [],
            selectedDepartment: null,
            editDepartment: null,
            deleteId: null,

            searchRoleList: [],

            searchInput: null,
            searchDepartment: null,
            searchRole: null,

            currentPage: 0,
            perPage: 0,
            lastPage: 0,
            totalData:0,

            url:'/api/staffs',
            url_search:'',
            url_department:'',
            url_role:'',

            user: null,
            feature: this.getFeature(),

            loading: true,

            contractFiles: [],
            contractFilePreviews: [],
            editId: null,
            editIndex: null,

            selectedStaffName: null,

            buttonLoading: false,
            examList: [],
            selectedStaff: null,
            selectedExam: null,

            statusList: [
                {value: 'probation', name: 'Probation'},
                {value: 'permanent', name: 'Permanent'},
            ],
            selectedStatus: null,
            selectedProbationMonth: null,
        };
    },

    methods: {
        ...mapGetters(['getToken', 'getFeature']),
        statusChangeBtnClicked(item){
            this.selectedStaff = item;
            this.selectedStatus = this.statusList.find(status => status.value === item.status);
            // this.selectedStatus = item.status;
            this.selectedProbationMonth = null;
        },
        changeStatusBtnClicked(){
            if(!this.selectedStatus){
                this.showToastMessage(`Please Choose Status`, 'warn');
                return 1;
            }
            else if(this.selectedStatus.value === 'probation' && !this.selectedProbationMonth){
                this.showToastMessage(`Probation Month is Needed`, 'warn');
                return 1;
            }
            else{
                this.changeStatus();
            }
        },
        async changeStatus(){
            let formData = new FormData();
            formData.append('id', this.selectedStaff.id);
            formData.append('status', this.selectedStatus.value);
            if(this.selectedStatus.value === 'probation'){
                formData.append('probation_period', this.selectedProbationMonth);
            }
            let response = await postApiData({ url: '/api/update_staff_status', form_data: formData, token: this.getToken() });
            console.log('status change ',response)
            if(response.success){
                console.log('status change success')
                document.getElementById('close_change_status_modal').click();
                this.getStaffsList(1);
            } 
            else {
                this.$notify({
                    text: response.message,
                    type: "error"
                });
            }
            

        },
        async createExamBtnClicked(item){
            this.selectedStaff = item;
            this.selectedExam = null;
            let response = await getApiData({ url: '/api/hr/get_exam_by_role/' + item.roles[0].id + '/exam_type/exam', token: this.getToken() });
            if (response.data) {
                this.examList = response.data;
            }else {
                this.$notify({
                    text: response.message,
                    type: "error"
                });
            }
            console.log('selected staff id = ', this.selectedStaff)
        },
        createInterview(){
            if(!this.selectedExam){
                this.showToastMessage(`Please Choose Exam`, 'warn');
                return 1;
            }
            else{
                window.location.replace('/exam/' + this.selectedStaff.id+ '/assessment/' + this.selectedExam.id )
                // console.log('staff id = ' + this.selectedStaff.id , 'exam id = ' + this.selectedExam.id)
            }
        },

        contractFilesChange(e){
            const files = Array.from(e.target.files);
            // Clear previous selections if you want to replace, or remove this line to allow accumulating
            this.contractFiles = [];
            this.contractFilePreviews = [];
            files.forEach(file => {
                this.contractFiles.push(file);
                this.contractFilePreviews.push(URL.createObjectURL(file));
            });
        },

        removeContractBtnClicked(index){
            this.contractFiles.splice(index,1);
            this.contractFilePreviews.splice(index,1);
            // Reset the file input so user can re-select files
            this.$refs.contractInput.value = '';
        },

        contractUploadBtnForStaffClicked(id, index){
            this.editId = id;
            this.editIndex = index;
            this.selectedStaffName = this.staffList[index].name;
        },

        uploadContractsBtnClicked(){
            this.buttonLoading = true;
            let formData = new FormData();
            if (this.contractFiles.length > 0) {
                this.contractFiles.forEach(file => {
                    formData.append('contract_images[]', file);
                });
            }else{
                this.showToastMessage("At least one contract file should be uploaded", "warn");
                this.buttonLoading = false;
                return;
            }

            postApiData({url: `/api/staff/${this.staffList[this.editIndex].id}/upload_contracts`, form_data: formData, token: this.getToken()})
            .then((response)=>{
                this.buttonLoading = false;
                if(response.success){
                    this.getStaffsList(1);
                    this.selectedStaffName = null;
                    this.editId = null;
                    this.editIndex = null;

                    this.$refs.contractInput.value = '';
                    this.contractFiles = [];
                    this.contractFilePreviews = [];
                }else{
                    this.showToastMessage(response.message, 'error');
                }
                document.getElementById('btn-close-upload-modal').click();
            });
        },

        async getDepartmentList() {
            let url = `/api/departments`;
            let response = await getApiData({ url: url, token: this.getToken() });
            if (response.data) {
                this.departmentList = response.data;
            }
        },

        async getStaffsList(pageNumber) {
            this.loading = true;
            console.log('loading');
            let url_page_number = '';
            if(this.url_search || this.url_department || this.url_role){
                url_page_number = '&page=' + pageNumber
            }
            else{
                url_page_number = '?page=' + pageNumber
            }
            // let url = `/api/staffs?page=${pageNumber}`;
            // if (this.searchInput && this.searchCategory) {
            //     url = `/api/staffs?search_input=${this.searchInput}&department_id=${this.searchCategory.id}&page=${pageNumber}`;
            // }
            // if (this.searchInput && !this.searchCategory) {
            //     url = `/api/staffs?search_input=${this.searchInput}&page=${pageNumber}`;
            // }
            // if ((!this.searchInput) && this.searchCategory) {
            //     url = `/api/staffs?department_id=${this.searchCategory.id}&page=${pageNumber}`;
            // }
            let url = this.url + this.url_search + this.url_department + this.url_role + url_page_number;
            getApiData({url: url, token: this.getToken()})
            .then((response)=>{
                if(response.data){
                    this.loading = false;
                    this.staffList = response.data.data;
                    this.lastPage = response.data.last_page;
                    this.currentPage = pageNumber;
                    this.perPage = response.data.per_page;
                    this.totalData = response.data.total;
                    console.log('loading done');
                }
            });
            // const response = await getApiData({ url: url, token: this.getToken() });
            // if (response.data != null) {

            //     this.staffList = response.data.data;
            //     this.lastPage = response.data.last_page;
            //     this.currentPage = pageNumber;
            //     this.perPage = response.data.per_page;
            //     this.totalData = response.data.total;
            // }
        },

        isActiveToggled(id) {
            let index = this.staffList.findIndex(staff => staff.id == id);
            if (index != -1) {
                if (this.staffList[index].is_active == 1) {
                    this.staffList[index].is_active = 0;
                }
                else {
                    this.staffList[index].is_active = 1;
                }

                let url = `/api/is_active`;
                let formData = new FormData();
                formData.append('id', id);
                formData.append('type', 'staff');
                let response = postApiData({ url: url, form_data: formData, token: this.getToken() });
            }
        },

        async confirmDeleteBtnClicked() {
            let url = `/api/staff/${this.deleteId}`;
            let response = await deleteApiData({ url: url, token: this.getToken() });
            if (response.success) {
                alert(`deleted`);
            }
        },



        searchDepartmentChange(){
            if(this.searchInput){
                this.url_department = '&department_id[]='+this.searchDepartment.id;
            }
            else{
                this.url_department = '?department_id[]='+this.searchDepartment.id;
            }
            this.searchRoleList = this.searchDepartment.roles;
            this.searchRole = null;
            this.getStaffsList(1);
        },
        searchRoleChange(){
            this.url_role = '&role_id[]='+this.searchRole.id;
            this.getStaffsList(1);
        },
        async searchBtnClicked() {
            this.url_search = '?search_input=' + this.searchInput
            this.getStaffsList(1);
        },
        clearSearchBtnClicked() {
            this.searchInput = null;
            this.url_search = '';
            this.searchDepartment = null;
            this.searchRoleList = [];
            this.searchRole = null;
            this.getStaffsList(1);
        },

        // async searchBtnClicked() {
        //     this.getStaffsList(1);
        // },

        // clearSearchBtnClicked() {
        //     this.searchInput = null;
        //     this.searchCategory = null;
        //     this.getStaffsList(1);
        // },

        showToastMessage(message, type='warn', title=null){
            this.$notify({
                title: title,
                text: message,
                type: type
            });
        },
    },

    created() {
        this.getDepartmentList();
        this.getStaffsList(1);
    },

    mounted() {
        // this.feature = this.getFeature();
        // this.user = this.getUser();
        initTE({ Modal, Ripple, Input, Select, Dropdown })
    }
}
</script>
